import moment from 'moment-timezone';

// eslint-disable-next-line import/prefer-default-export
export const getSearchDate = (reservation) => {
  if (moment(reservation?.time, 'HH:mm:ss').isBefore(moment('05:00', 'HH:mm'))) {
    return moment(reservation?.day, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD');
  }

  return reservation?.day;
};
